import React, { useCallback, useEffect, useState } from 'react';
import {
    Button,
    Card,
    CardContent,
    CircularProgress,
    Grid,
    IconButton,
    Typography,
    Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TodayIcon from '@mui/icons-material/Today';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import Groups2Icon from '@mui/icons-material/Groups2';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import QuickreplyIcon from '@mui/icons-material/Quickreply';
import ConstructionIcon from '@mui/icons-material/Construction';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import SavingsIcon from '@mui/icons-material/Savings';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import CameraEnhanceIcon from '@mui/icons-material/CameraEnhance';
import SettingsIcon from '@mui/icons-material/Settings';
import { AconSemana } from '../global/acondia/AconSemana';
import { getAnuncios, getopcinesMenu } from '../services/apis';
import { Anuncio } from '../global/Anuncio';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
//mapa de iconos
let tamIco = 50;
const iconMapping = {
    TodayIcon: <TodayIcon sx={{ fontSize: tamIco }} />,
    FolderSpecialIcon: <FolderSpecialIcon sx={{ fontSize: tamIco }} />,
    Groups2Icon: <Groups2Icon sx={{ fontSize: tamIco }} />,
    AdminPanelSettingsIcon: <AdminPanelSettingsIcon sx={{ fontSize: tamIco }} />,
    QuickreplyIcon: <QuickreplyIcon sx={{ fontSize: tamIco }} />,
    ConstructionIcon: <ConstructionIcon sx={{ fontSize: tamIco }} />,
    AccessAlarmIcon: <AccessAlarmIcon sx={{ fontSize: tamIco }} />,
    SavingsIcon: <SavingsIcon sx={{ fontSize: tamIco }} />,
    LocalDiningIcon: <LocalDiningIcon sx={{ fontSize: tamIco }} />,
    LocalActivityIcon: <LocalActivityIcon sx={{ fontSize: tamIco }} />,
    AconSemana: <AconSemana />,
    AssignmentIcon: <AssignmentIcon sx={{ fontSize: tamIco }} />,
    CheckroomIcon: <CheckroomIcon sx={{ fontSize: tamIco }} />,
    CameraEnhanceIcon: <CameraEnhanceIcon sx={{ fontSize: tamIco }} />,
    SettingsIcon: <SettingsIcon sx={{ fontSize: tamIco }} />,
    AccountCircleOutlinedIcon: <AccountCircleOutlinedIcon sx={{ fontSize: tamIco }} />
};

export const MainMenu = () => {
    const navigate = useNavigate();

    const [loaded, setLoaded] = useState(false);
    const [opciones, setOpciones] = useState([]);
    const [anuncios, setAnuncios] = useState([]);

    const cargarOpciones = useCallback(async () => {
        try {
            const response = await getopcinesMenu();
            setOpciones(response.data);
            setLoaded(true);
        } catch (error) {
            console.error("Error al cargar opciones del menu:", error);
            localStorage.clear();
            navigate("/login");
        }
    }, [navigate]);

    const cargarAnuncios = useCallback(async () => {
        try {
            const response = await getAnuncios();
            if (response && response.success) {
                setAnuncios(response.data); // actualizar estado
            }
        } catch (error) {
            console.error("Error al cargar anuncios:", error);
        }
    }, []);

    useEffect(() => {
        cargarOpciones();
        cargarAnuncios();
    }, [cargarOpciones, cargarAnuncios]);

    const esActivo = (fecha) => {
        const ahora = new Date();
        const fechaAnuncio = new Date(fecha);
        const diffMs = ahora - fechaAnuncio;
        return diffMs <= 30 * 60 * 1000; // menos de 30 minutos
    };

    return (
        <div className='menu-principal fade-in-2'>
            {!loaded && (<CircularProgress />)}
            {loaded && (
                <Grid container spacing={2}
                    sx={{ justifyContent: "center" }}>
                    <Grid sx={{ mb: 0, textAlign: 'center' }}
                        size={{ xs: 12 }}>
                        {anuncios.length >= 1 && (
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={async () => {
                                    // 1. Limpiar anuncios ocultos
                                    localStorage.removeItem("anunciosOcultos");
                                    // 2. Recargar anuncios
                                    const response = await getAnuncios();
                                    if (response && response.success) {
                                        setAnuncios(response.data); // actualizar estado para que se muestren
                                    }
                                    window.location.reload();
                                }}
                            >
                                Mostra anuncis ocults

                            </Button>
                        )}
                    </Grid>
                    {/* Bloque anuncios */}
                    {anuncios.length > 0 && (
                        <Grid
                            size={{ xs: 12 }}>
                            <Box sx={{ mb: 0 }}>
                                {anuncios.map((anuncio) => (
                                    <Anuncio
                                        key={anuncio.idAnuncio + '-' + anuncio.fecha} // combinamos id y fecha para forzar render
                                        anuncio={anuncio}
                                        esActivo={esActivo}
                                    />
                                ))}
                            </Box>
                        </Grid>
                    )}
                    <Grid
                        container
                        direction="row"
                        size={{ xs: 12 }}
                        sx={{ justifyContent: "center", alignItems: "center" }}>
                        {/* Opciones del menú */}
                        {opciones.filter((opcion) => opcion.tipo === 1).map((opcion) => (
                            <Grid
                                size={{ xs: 12 }}>
                                {opcion.tipo === 1 && iconMapping[opcion.icon]}
                            </Grid>
                        ))}
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        gap={2}
                        size={{ xs: 12 }}
                        sx={{ justifyContent: "center", alignItems: "center" }}>
                        {/* Opciones del menú */}
                        {opciones.filter((opcion) => opcion.tipo === 0).map((opcion) => (
                            <Grid
                                container
                                direction="row"
                                size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                                sx={{ justifyContent: "center", alignItems: "center" }}>
                                <Grid
                                    size={{ xs: 12 }}>
                                    {opcion.tipo === 1 && iconMapping[opcion.icon]}
                                </Grid>
                                {opcion.tipo === 0 && (
                                    <Grid
                                        size={{ xs: 12 }}>
                                        <Card
                                            onClick={() => navigate(opcion.url)}
                                            className="menu-card ki-interactive-card"
                                        >
                                            <CardContent className="ki-menu-card-content">
                                                <Grid container
                                                    sx={{ justifyContent: "space-between", alignItems: "center" }}>
                                                    <IconButton size="small" color="primary">
                                                        {iconMapping[opcion.icon]}
                                                    </IconButton>
                                                    <Typography variant="h6">
                                                        {opcion.nombre.toUpperCase()}
                                                    </Typography>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                )}
                            </Grid>

                        ))}
                    </Grid>


                </Grid>
            )}
        </div>
    );
};
